import { FC } from 'react';
import Agriculture from '@mui/icons-material/Agriculture';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import Elderly from '@mui/icons-material/Elderly';
import Explore from '@mui/icons-material/Explore';
import Luggage from '@mui/icons-material/Luggage';
import School from '@mui/icons-material/School';
import Storefront from '@mui/icons-material/Storefront';
import Work from '@mui/icons-material/Work';

const ICON_BY_SLUG: Record<string, FC<any>> = {
  agricultor: Agriculture,
  aposentado: Elderly,
  empreendedor: Storefront,
  estudante: School,
  motorista: DirectionsCar,
  trabalhador: Work,
  turista: Luggage,
};

export interface JourneyIconProps {
  slug?: string;
  audienceSlugs?: string[];
  className?: string;
}

export const JourneyIcon: FC<JourneyIconProps> = ({
  slug,
  audienceSlugs,
  className,
}) => {
  const key = [slug, ...(audienceSlugs || [])].find(
    (candidate) => candidate && ICON_BY_SLUG[candidate]
  );

  const Icon = (key && ICON_BY_SLUG[key]) || Explore;

  return <Icon className={className} />;
};
